import TripNotificationsContainer from './TripNotificationsContainer';

export default TripNotificationsContainer;
